// @intent: Shared telemetry event names for the native match-3 renderer.
// @flow: native match3 runtime emits these events; verifiers assert their sequence.
// @stale: Keep aligned with generation verifier requiredEvents.

export const match3TelemetryEvents = {
  ready: 'ready',
  tutorialVisible: 'tutorial_visible',
  firstInteraction: 'first_interaction',
  meaningfulStateChange: 'meaningful_state_change',
  objectiveProgress: 'objective_progress',
  matchResolved: 'match_resolved',
  refillComplete: 'refill_complete',
  endcardVisible: 'endcard_visible',
  ctaShown: 'cta_shown',
  // Б1: special tile lifecycle events.
  specialSpawned: 'special_spawned',
  specialDetonated: 'special_detonated',
} as const;

export type Match3TelemetryEventName = typeof match3TelemetryEvents[keyof typeof match3TelemetryEvents];
